// Versjon av samtykketeksten for posisjonsdeling. Økes når teksten endrer hva posisjonen
// brukes til, slik at sjåfører som godtok en eldre tekst blir spurt på nytt.
// v1: posisjon til å vise og sortere oppdrag i nærheten
// v2: i tillegg ser bestilleren posisjonen fra tildeling til levering
export const LOCATION_CONSENT_VERSION = 2;

export function locationConsentVersion(userDoc) {
  if (userDoc?.locationConsentVersion != null) return userDoc.locationConsentVersion;
  return userDoc?.locationConsentAt ? 1 : 0;
}

export function hasCurrentLocationConsent(userDoc) {
  return locationConsentVersion(userDoc) >= LOCATION_CONSENT_VERSION;
}
